const mobileDeviceRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

// Read once at load: navigating inside the platform drops ?mobile=true / ?header=false from the URL
const launchedInApp = /mobile/i.test(window.location.href);
const headerHidden = new URLSearchParams(window.location.search).get('header') === 'false';

// A phone's own browser, not the native app's webview
export const isPhoneBrowser = () =>
  mobileDeviceRegex.test(window.navigator.userAgent) &&
  !launchedInApp &&
  !window.ReactNativeWebView;

export const shouldShowMobileWarning = () => isPhoneBrowser() && !headerHidden;
